<template>

<!--
	The OIDC return landing (/auth/callback). It completes the geekgroup
	auth-code exchange (oidc.complete -> account.complete), then routes back to
	the page the sign-in began from (or /). Purely transitional: a quiet "Signing
	you in…" while the token exchange runs, an error line if it fails.
-->

<div class="callback">

	<app-mark :size="34" class="callback-mark" />

	<p v-if="!error" class="callback-note">Signing you in…</p>

	<template v-else>
		<p class="callback-error">{{ error }}</p>
		<router-link to="/" class="callback-link">Back to today’s puzzle</router-link>
	</template>

</div>

</template>

<script>

import oidc from '../service/oidc'

export default {

	name: 'Callback',

	data: function() {

		return {
			error: ''
		}

	},

	created: function() {

		var self = this

		// swap the auth code for an id_token, then exchange it for a boxart
		// session via the account store; land back where sign-in began
		oidc.complete().then(function(result) {

			var returnTo = (result && result.returnTo) || '/'

			if (!result || result.error || !result.id_token) {

				self.error = 'Sign-in didn’t complete. Please try again.'
				return

			}

			self.$store.dispatch('account/complete', {
				id_token: result.id_token,
				access_token: result.access_token
			}).then(function(json) {

				if (json && json.token) self.$router.replace(returnTo)
				else self.error = 'Sign-in didn’t complete. Please try again.'

			})

		})

	}

}

</script>

<style scoped>

.callback {
	flex: 1;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 14px;
	padding: 40px 16px;
}

.callback-note {
	font-family: var(--font-body);
	font-size: 15px;
	color: var(--muted-2);
	margin: 0;
}

.callback-error {
	font-family: var(--font-body);
	font-size: 15px;
	color: var(--wrong);
	margin: 0;
}

.callback-link {
	font-family: var(--font-body);
	font-size: 14px;
	font-weight: 500;
	color: var(--accent);
	text-decoration: none;
}

.callback-link:hover {
	text-decoration: underline;
}

</style>
